import { useAuth } from "./useAuth";

export function usePermissions() {
  const { user } = useAuth();
  return {
    isAdmin: user?.role === "admin",
    isVeterinario: user?.role === "veterinario",
    isAuxiliar: user?.role === "auxiliar",
    canManage: user?.role === "admin",
    // Papel financeiro (04/09): admin tambem ve. A trava real do dinheiro
    // e do lado da clinica; aqui e so o que aparece na tela.
    isFinanceiro: user?.role === "financeiro" || user?.role === "admin",
    // Coordenação de escala (24/09): admin OU 'escala' montam a escala —
    // turno, pedido de turno, tipos de turno, restrições e calendário.
    // Dinheiro, cadastro de gente e usuários seguem em isAdmin/isFinanceiro.
    podeGerirEscala: user?.role === "admin" || user?.role === "escala",
    isEscala: user?.role === "escala",
  };
}
